import { cn } from '@/utils/cn';
import { forwardRef } from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  hint?: React.ReactNode;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ label, error, hint, className, id, ...props }, ref) => {
    const inputId = id || label?.toLowerCase().replace(/\s+/g, '-');

    return (
      <div className="w-full">
        {label && (
          <label
            htmlFor={inputId}
            className="block text-sm font-medium text-md-ink mb-2"
          >
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          className={cn(
            `w-full px-4 py-2 border-2 border-md-graphite rounded
             bg-md-fog text-md-ink placeholder:text-md-slate
             focus:outline-none focus:border-md-sky-strong
             disabled:opacity-50 disabled:cursor-not-allowed
             transition-colors duration-120`,
            error && 'border-md-error',
            className
          )}
          {...props}
        />
        {hint && !error && (
          <p className="text-xs text-md-slate mt-2">{hint}</p>
        )}
        {error && (
          <p className="text-xs text-md-error mt-2">{error}</p>
        )}
      </div>
    );
  }
);

Input.displayName = 'Input';
